import React from "react";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import * as Yup from "yup";

import { helpText } from "../components/form-fields/common";
import InputField from "../components/form-fields/InputField";
import useFocusOnError from "../components/hooks/useFocusOnError";
import { retrieveCSRFToken } from "../utils/ajax";

const formSchema = Yup.object().shape({
  fullname: Yup.string()
    .min(2, "Too Short!")
    .max(50, "Too Long!")
    .required("Required"),
  email: Yup.string().email("Invalid email").required("Required"),
  subject: Yup.string()
    .min(2, "Too Short!")
    .max(50, "Too Long!")
    .required("Required"),
  message: Yup.string()
    .min(10, "Too Short!")
    .max(500, "Too Long!")
    .required("Required"),
});

const defaultFormValues = {
  fullname: "",
  email: "",
  subject: "",
  message: "",
};

const register = async (params, { setSubmitting, setErrors, resetForm }) => {
  console.log("### email sent", params);
  const response = await fetch("/__legacy/contact/", {
    method: "POST",
    headers: {
      "X-CSRFToken": retrieveCSRFToken(),
      "Content-Type": "application/json",
    },
    body: JSON.stringify(params),
  });

  if (response.status === 204) {
    toast.success("Message Recieved! We'll get back to you shortly.");
    resetForm({ ...defaultFormValues });
    return;
  }

  console.log("### Something went wrong...", response);
};

const Contact = () => {
  const formik = useFormik({
    initialValues: { ...defaultFormValues },
    onSubmit: register,
    validationSchema: formSchema,
  });

  useFocusOnError(formik);

  return (
    <React.Fragment>
      <section className="hero is-primary">
        <div className="hero-body">
          <div className="container is-max-desktop">
            <h1 className="title">Contact</h1>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container is-max-desktop">
          <p className="content">
            Please fill out the contact form below to get in touch with us.
          </p>

          <form onSubmit={formik.handleSubmit}>
            <InputField fieldName="fullname" label="Name" formik={formik} />

            <InputField fieldName="email" label="Email" formik={formik} />

            <InputField fieldName="subject" label="Subject" formik={formik} />

            <div className="field">
              <label className="label" htmlFor="message">
                Message
              </label>
              <div className="control">
                <textarea
                  className="textarea"
                  id="message"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.message}
                />
              </div>
              {helpText(formik, "message")}
            </div>

            <button
              type="submit"
              className="button is-success"
              disabled={formik.isSubmitting}
            >
              Send
            </button>
          </form>
        </div>
      </section>
    </React.Fragment>
  );
};

export default Contact;
